<div class="toolbar" [ngClass]="additionalClasses || []">
  <ng-content></ng-content>
</div>
